/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.customOptions = this.querySelectorAll('[data-customOption]');
    this.metal_swatches = this.querySelector('.metal-swatch');
    this.cartElement = document.querySelector('cart-form'); 
    this.ring_size_option =  this.querySelector('[data-customOption].ring-size-selection') ||  this.querySelector('[data-customOption].clouser-selection');
    this.ring_size_selection = this.ring_size_option?.querySelector('[name="ring_size_selection"]') || this.ring_size_option?.querySelector('[name="properties[Closure]"]');
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.customOptions.forEach((option)=>{
      let selectEle = option.querySelector('select');
      selectEle.addEventListener('change', ()=> option.classList.remove('error'));
    });

    if(this.ring_size_option){
      if(this.ring_size_selection.checked == true){
        this.choose_ringsize = 'later';
        this.ring_size_option.classList.remove('error');
        this.ring_size_option.querySelector('select').value = "";
        this.ring_size_option.querySelector('select').disabled = true;
      }

      this.ring_size_selection.addEventListener('change', (_event)=>{
        if(this.ring_size_selection.checked == true){
          this.choose_ringsize = 'later';
          this.ring_size_option.classList.remove('error');
          this.ring_size_option.querySelector('select').value = "";
          this.ring_size_option.querySelector('select').dispatchEvent(new Event("change"));
          this.ring_size_option.querySelector('select').disabled = true;

          // let variantPicker = this.form.querySelector('variant-select');
          // if(variantPicker) variantPicker.toggleAddButton();
        }else{
          this.choose_ringsize = 'now';
          this.ring_size_option.querySelector('select').removeAttribute("disabled");
        }
      });
    }

    const metalButtons = this.querySelectorAll('.metal-selection-btn');
    const swatchInputs = this.querySelectorAll('.metal-swatch [data-metaltype]');
    metalButtons.forEach(btn => {
        btn.addEventListener('click', (evt) => {
          const selectedValue = evt.currentTarget.dataset.value;

          // Remove 'active' class from the currently active button
          this.querySelector('.metal-selection-btn.active')?.classList.remove('active');
          evt.currentTarget.classList.add('active');

          if(selectedValue == 'gold'){
            // Show/hide swatch inputs based on the selected metal type
            swatchInputs.forEach(input => {
              input.classList.toggle('d-none', input.dataset.metaltype !== selectedValue);
            });
            const visibleInputs = Array.from(swatchInputs).filter(input => !input.classList.contains('d-none'));
            visibleInputs[0]?.querySelector('.swatch-label')?.click();
          }else{
            swatchInputs.forEach(input => {
              if (input.dataset.metaltype != selectedValue) {
                input.classList.add('d-none');
              }
            });
            this.querySelector(`.metal-swatch [data-metaltype="${selectedValue}"] .swatch-label`)?.click();
          }
        });
    });
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    let submitForm = true; 
    const submitButton = this.querySelector('[type="submit"]');
    let variantId = this.querySelector('input[name="id"]').value;

    if(variantId == ''){
      if(this.metal_swatches && !this.metal_swatches.querySelector('input[type="radio"]:checked')){
        this.scrollToField(this.metal_swatches);
        window.notificationEle.updateNotification('Metal Type', 'Choose option from available metal types.', {
          type: 'error',
          timeout: 10000
        });
        this.metal_swatches.classList.add('selection-error');
      }
      return false;
    }

    this.customOptions.forEach((option)=>{
      let selectEle = option.querySelector('select');
      if(selectEle.value == '' && selectEle.disabled == false){
        submitForm = false;
        option.classList.add('error');
        this.scrollToField(option);
        window.notificationEle.updateNotification(selectEle.dataset.title, selectEle.dataset.text, {
          type: 'error',
          timeout: 10000
        });
        return false;
      }
    });

    if(!submitForm) return false;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    let mainProduct = JSON.parse(serializeForm(this.form));
    if(mainProduct.properties == undefined) mainProduct.properties = {};
    
    if(this.ring_size_option && this.choose_ringsize == 'later') mainProduct.properties['Ring Size'] = 'Choose later';

    if(window.globalVariables.product_rush_delivery.enable == true){
      let rushDelivery = document.querySelector('[data-rushSelect]');
      if(rushDelivery && rushDelivery.value == 'rush'){
        let selectedOption = rushDelivery.options[rushDelivery.selectedIndex];
        let rush_date = selectedOption.dataset.date || null;
        let rush_fees = selectedOption.dataset.fees || 110;

        if(rush_fees != null && rush_date != null){
          mainProduct.properties['_delivery_type'] = 'rush';
          mainProduct.properties['_rush_fees'] = rush_fees;
          mainProduct.properties['Estimated Delivery'] = `${rush_date} (Rush Delivery)`;
        }
      }
    }
  
    addItems.push(mainProduct);
    const body = JSON.stringify({
      items: addItems,
      sections: 'template-cart'
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      let cartSection = dataJSON.sections['template-cart'];
      this._klavitoATC(cartSection);
        
      if(this.cartElement){
        this.cartElement.getCartData('open_drawer');
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
    });
  }

  _klavitoATC(cartSection){
    let _learnq = window._learnq || [];
    
    let parser = new DOMParser();
    let cartHTML = parser.parseFromString(cartSection, 'text/html');
    let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
    let cart_json = JSON.parse(cartJSONEle.textContent);

    let cart = {
      total_price: cart_json.total_price/100,
      $value: cart_json.total_price/100,
      total_discount: cart_json.total_discount,
      original_total_price: cart_json.original_total_price/100,
      items: cart_json.items
    }
    _learnq.push(['track', 'Added to Cart', cart]);
  }

  /**
   * Scroll to error when product form field is required and empty
   * 
   * @param {element} node target element
   */

  scrollToField(element) {
    element.scrollIntoView({ behavior: "smooth", block: "start"});
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelect extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.variantID = this.form.querySelector('input[name="id"]');
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;
    this.metalTone = this.form.querySelector('[data-metaltone]');
    this.metal_swatches = this.form.querySelector('.metal-swatch');
    this.ring_size_option =  this.form.querySelector('[data-customOption].ring-size-selection') || this.form.querySelector('[data-customOption].clouser-selection');
    this.ring_size_selection = this.ring_size_option?.querySelector('[name="ring_size_selection"]') || null;
  }

  connectedCallback() {
    // Element Connected callback
    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    if(this.querySelector('select') && this.querySelector('select').disabled == true) return;

    this.setCurrentVariant();

    if(this.metal_swatches){
      this.metal_swatches.classList.remove('selection-error');
    }

    if (!this.currentVariant || this.currentVariant == undefined) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
      document.dispatchEvent(new Event('variant:changed'));
      const productPage = this.closest('[data-product-container]');
      this.renderProductInfo(this.currentVariant, productPage);
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.form.querySelectorAll('variant-select .variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.form.querySelectorAll('variant-radios fieldset'));
    return fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value || null;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    
    if(this.form.querySelector('variant-radios') && this.form.querySelector('variant-select')){
      const radio_options = this._getOptionsFromRadio();
      const select_options = this._getOptionsFromSelect();
      options = radio_options.concat(select_options);
    }

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = `option${option.dataset.optionindex}`;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      
      const selectedOption = this.currentVariant[labelID];
      if(selectedOption == undefined) return;

      if(option.classList.contains('metal-swatch') && selectedOption.indexOf('Gold') > -1){
        let final_label = option.querySelector('input[type="radio"]:checked');
        label.innerHTML = final_label.dataset.label;

        this.metalTone.removeAttribute('disabled');
        this.metalTone.setAttribute('value', final_label.dataset.tone);        
      }else{
        label.innerHTML = this.currentVariant[labelID];

        if(option.classList.contains('metal-swatch')){
          this.metalTone.removeAttribute('value');
          this.metalTone.setAttribute('disabled', true);
        }        
      }      
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Price details based on current variant
   */
  priceUpdate(currentVariant, container){
    let price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format_with_currency);
    let compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    let currentSku=currentVariant.sku;
    let skuElement=container.querySelector('[data-currentsku]');
    if(skuElement) skuElement.innerText = currentSku;

    if(priceElement) priceElement.innerHTML = price;
    if(comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if(currentVariant.compare_at_price <= 0){
        comparePriceElement.style.display = 'none';
      }else{
        comparePriceElement.style.display = 'inline-block';
      }
    }

    if(priceElement.closest('.price-wrapper')){
      priceElement.closest('.price-wrapper').querySelector('.from-text')?.classList.add('d-none');
    }
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container) {
    if(!currentVariant || !container) return;
   
    this.priceUpdate(currentVariant, container);
    this.updateOptionLabel(this.form); 
    this.updateRushFees(currentVariant);

    const featured_image = currentVariant.featured_image || null;
    
    if(featured_image != null && container.querySelector('.varient-img-div') != null){
      
      let imge_src =  currentVariant.featured_media.preview_image.src;
      container.querySelector('.varient-img-div').innerHTML='';
      const picture = document.createElement("picture");
      picture.classList.add("w-100", "h-100");

      // Define breakpoints and widths
      const sources = [
        { media: "(min-width: 1200px)", width: 900 },
        { media: "(min-width: 992px)", width: 700 },
        { media: "(min-width: 1200px)", width: 600 },
        { media: "(min-width: 992px)", width: 500 },
        { media: "(max-width: 991px)", width: 500 },
      ];
      
      // Create source elements
      sources.forEach(({ media, width }) => {
        const source = document.createElement("source");
        source.setAttribute("media", media);
        source.setAttribute("srcset", `${imge_src}&width=${width}`);
        picture.appendChild(source);
      });

      // Create img fallback
      const img = document.createElement("img");
      img.src = `${imge_src}&width=50`;
      img.loading = "eager";
      img.fetchPriority = "high";
      img.alt = currentVariant.name;
      img.width = 1920;
      img.height = 1920;
      img.classList.add("w-100", "h-100", "object-fit-cover");

      // Append img to picture
      picture.appendChild(img);
      container.querySelector('.varient-img-div').appendChild(picture);
      container.querySelector('.varient-img-div-main').classList.add('opacity-hidden');

      
    }
  }

  /**
   * Render rush delivery fees based on current variant price
   * @param {object} currentVariant 
   */
  updateRushFees(currentVariant){
    const rushOption = document.querySelector('[data-rushselect] option[value="rush"]') || null;
    if(rushOption == null) return;

    let final_rush_fees = 49;
    if(currentVariant.price <= 50000){
      final_rush_fees = 4900;
    }else if(currentVariant.price <= 150000){
      final_rush_fees = 9900;
    }else if(currentVariant.price <= 350000){
      final_rush_fees = 15000;
    }else if(currentVariant.price > 350000){
      final_rush_fees = 34900;
    }    

    rushOption.setAttribute('data-fees', Utility.formatMoney(final_rush_fees, "{{amount}}"));
    rushOption.innerHTML = `${rushOption.innerText.split('+')[0]} +${Utility.formatMoney(final_rush_fees, "${{amount}}")}`;
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    let textContent = window.variantStrings.choose_option;
    let setDisabled = false;
    let ringsizeSelect = this.ring_size_option?.querySelector('select');
    let selectedRingSize = ringsizeSelect?.value || '';

    if (this.variantID.value == '') {
      // console.log('Case 1');
      setDisabled = false;
      textContent = window.variantStrings.choose_option;
      if(ringsizeSelect && ringsizeSelect.disabled) textContent = window.variantStrings.select_metal;
    } else if(status == 'disable') {
      // console.log('Case 2');
      setDisabled = true;
      textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      // console.log('Case 3');
      setDisabled = true;
      textContent = window.variantStrings.soldOut;
    } else{
      // console.log('Case 4');
      setDisabled = false;
      if (this.ring_size_option && selectedRingSize === '' && (ringsizeSelect.disabled == false || this.ring_size_option.classList.contains('clouser-selection'))) {
        textContent = window.variantStrings.select_ringsize;
      }else{
        textContent = (this.form.classList.contains('cart-upsell-form')) ? window.variantStrings.upsellAddText : window.variantStrings.addToCart;
        textContent += ` ${Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format)} ${Shopify.currency.active}`;
      }
    }

    (setDisabled == true) ? this.addBtn.setAttribute('disabled', true) : this.addBtn.removeAttribute('disabled');
    this.addBtn.querySelector('.add-text').textContent = textContent;
    this.addBtn.setAttribute('aria-label', textContent);
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
customElements.define('variant-select', VariantSelect);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelect {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;
  }
}
customElements.define('variant-radios', VariantRadios);